import { render, staticRenderFns } from "./StatistiquesProduction.vue?vue&type=template&id=32a88aa0&"
import script from "./StatistiquesProduction.vue?vue&type=script&lang=js&"
export * from "./StatistiquesProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports